import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline, Visibility } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import LeaveViewController from "../../redux/actions/leaveApiAction";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import LeaveRequestFormModal from "./AddLeaveRequest";
import ViewLeaveModal from "./ViewLeaveInfo";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import "../../styles/styles.css";
import "../../styles/layout.css";
import usePermission from "../../utils/usePermission";

const LeaveListPage = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const userType = localStorage.getItem("user_type");

  const { getEmployees } = EmployeeProfileVeiwController();
  const { getLeaves, updateLeaveStatus } = LeaveViewController();
  const { hasPermission } = usePermission();

  const { employee_data } = useSelector((state) => state.employeeProfile);
  const { leaves } = useSelector((state) => state.leave);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editLeave, setEditLeave] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);

  useEffect(() => {
    // dispatch(getEmployees());
    dispatch(getLeaves());
  }, []);

  const openModalForCreate = () => {
    setEditLeave(null);
    setShowModal(true);
  };

  const handleView = (leave) => {
    setSelectedLeave(leave);
    setShowViewModal(true);
  };

  const handleStatusChange = (leaveId, selectedStatus) => {
    dispatch(updateLeaveStatus(leaveId, selectedStatus));
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left"
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80
    },
    {
      headerName: "Employee",
      field: "employee",
      flex: 1
    },
    {
      headerName: "Leave Type",
      field: "leave_type",
      flex: 1
    },
    {
      headerName: "Leave Dates",
      valueGetter: (params) =>
        `${params.data.leave_start_date} - ${params.data.leave_end_date}`,
      flex: 1.2
    },
    {
      headerName: "Total Days",
      field: "total_leave_days",
      maxWidth: 120
    },
    {
      headerName: "Status",
      field: "approval_status",
      flex: 1,
     cellRenderer: (params) => {
  const status = params.value;
  const leaveId = params.data.id;

  const canChangeStatus =
    hasPermission("leave_list", "approve") ||
    hasPermission("leave_list", "reject");

  if (canChangeStatus) {
    return (
      <select
        value={status}
        onChange={(e) => handleStatusChange(leaveId, e.target.value)}
        style={{
          backgroundColor: "white",
          color:
            status === "pending"
              ? "#ffc107"
              : status === "approved"
              ? "#28a745"
              : "#dc3545",
          border: "none",             // remove border
          outline: "none",            // remove focus outline
          padding: "2px 24px 2px 4px",// leave space for arrow
          fontWeight: "bold",
          appearance: "none",         // remove default style
          WebkitAppearance: "none",
          MozAppearance: "none",
          backgroundImage: "url('data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"10\" viewBox=\"0 0 10 10\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><polygon points=\"0,0 10,0 5,5\"/></svg>')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 4px center",
          backgroundSize: "10px",
          cursor: "pointer"
        }}
      >
        <option value="pending" style={{ color: "#ffc107" }}>
          Pending
        </option>
        <option value="approved" style={{ color: "#28a745" }}>
          Approved
        </option>
        <option value="rejected" style={{ color: "#dc3545" }}>
          Rejected
        </option>
      </select>
    );
  } else {
    const colorClass =
      status === "approved"
        ? "text-success"
        : status === "rejected"
        ? "text-danger"
        : "text-warning";
    return <span className={colorClass}>{status}</span>;
  }
}

    },
    {
      headerName: "Actions",
      pinned: "right",
      maxWidth: 100,
      cellRenderer: (params) => (
        <Tooltip title="View">
          <IconButton size="small" onClick={() => handleView(params.data)}>
            <Visibility fontSize="small" />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  return (
    <div>
      <div
        className="d-flex align-items-center flex-wrap  mb-3"
        style={{ justifyContent: "space-between", gap: "12px" }}
      >
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          {hasPermission("leave_list", "create") && (
            <Button
              variant="contained"
              startIcon={<AddCircleOutline />}
              onClick={openModalForCreate}
              sx={{
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                textTransform: "none",
                paddingX: 2,
                height: "40px",
                fontSize: "0.875rem"
              }}
            >
              Add Leave
            </Button>
          )}

          {hasPermission("leave_list", "export") && (
            <ExportButton
              gridRef={gridRef}
              fileName="leaves.xlsx"
              exportColumns={[
                "employee.first_name",
                "employee.last_name",
                "leave_type",
                "leave_start_date",
                "leave_end_date",
                "total_leave_days",
                "approval_status"
              ]}
              disabled={selectedRows.length === 0}
            />
          )}
        </div>

        <div style={{ flexGrow: 1 }}>
          <Form.Control
            type="text"
            placeholder="Search employees..."
            style={{ height: "40px" }}
            value={searchTerm}
            onChange={(e) => {
              const value = e.target.value;
              setSearchTerm(value);

              // Filter the employees
              const lowercasedValue = value.toLowerCase();
              const filtered = leaves.filter((emp) => {
                return (
                  emp.employee?.toLowerCase().includes(lowercasedValue) ||
                  emp.leave_type?.toLowerCase().includes(lowercasedValue)
                );
              });

              setFilteredEmployees(filtered);
            }}
          />
        </div>

        <div>
          <PageSizeSelector
            pageSize={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />
        </div>
      </div>

      {/* <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Leave List</h3>
          </Col>
        </Row>
      </div> */}

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={searchTerm ? filteredEmployees : leaves}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <LeaveRequestFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editLeave}
      />

      <ViewLeaveModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        selectedLeave={selectedLeave}
      />
    </div>
  );
};

export default LeaveListPage;
